import React from 'react';
import './Sponsors.css';

import { 
  FaHandshake, 
  FaTrophy, 
  FaStore, 
  FaAward,
  FaEnvelope,
  FaPhone,
  FaGift,
  FaMedal,
  FaUsers,
  FaHeart,
  FaBullhorn,
  FaRocket
} from 'react-icons/fa';

const Sponsors = () => {
  return (
    <div className="sponsors-container">
      <div className="hero-section">
        <div className="hero-background-shapes">
          <div className="shape shape-1"></div>
          <div className="shape shape-2"></div>
          <div className="shape shape-3"></div>
        </div>
        <div className="hero-content">
          <h1><FaHandshake className="hero-icon" />Our Sponsors</h1>
          <p className="hero-subtitle">
            Partnering with amazing businesses to make the Segovia BBQ Cookoff possible
          </p>
        </div>
      </div>

      <div className="info-card">
        <FaTrophy className="card-icon" />
        <div className="card-content">
          <h2>Thank You to Our Sponsors</h2>
          <div className="sponsors-grid">
            <div className="sponsor-placeholder">
              <FaStore className="placeholder-icon" />
              <p>Sponsor logos and information will be featured here as partnerships are confirmed.</p>
              <p className="coming-soon">Coming Soon...</p>
            </div>
          </div>
        </div>
      </div>

      <div className="info-card opportunities-card">
        <FaRocket className="card-icon" />
        <div className="card-content">
          <h2>Sponsorship Opportunities</h2>
          <p className="opportunities-intro">
            Join us in supporting the BBQ community and showcase your business to hundreds of attendees!
          </p>
          
          <div className="sponsorship-levels">
            <div className="level-card premium">
              <FaMedal className="level-icon" />
              <h3>Premium Sponsor</h3>
              <div className="level-benefits">
                <div className="benefit-item">
                  <FaBullhorn className="benefit-icon" />
                  <span>Logo prominently displayed on all event materials</span>
                </div>
                <div className="benefit-item">
                  <FaUsers className="benefit-icon" />
                  <span>Dedicated booth space at the event</span>
                </div>
                <div className="benefit-item">
                  <FaTrophy className="benefit-icon" />
                  <span>Opportunity to present awards</span>
                </div>
                <div className="benefit-item">
                  <FaHeart className="benefit-icon" />
                  <span>Social media promotion and recognition</span>
                </div>
              </div>
            </div>

            <div className="level-card standard">
              <FaAward className="level-icon" />
              <h3>Standard Sponsor</h3>
              <div className="level-benefits">
                <div className="benefit-item">
                  <FaBullhorn className="benefit-icon" />
                  <span>Logo on event signage and website</span>
                </div>
                <div className="benefit-item">
                  <FaStore className="benefit-icon" />
                  <span>Vendor table opportunity</span>
                </div>
                <div className="benefit-item">
                  <FaHeart className="benefit-icon" />
                  <span>Social media mentions</span>
                </div>
              </div>
            </div>

            <div className="level-card supporter">
              <FaGift className="level-icon" />
              <h3>Supporter</h3>
              <div className="level-benefits">
                <div className="benefit-item">
                  <FaBullhorn className="benefit-icon" />
                  <span>Logo on event website</span>
                </div>
                <div className="benefit-item">
                  <FaHeart className="benefit-icon" />
                  <span>Recognition at the event</span>
                </div>
              </div>
            </div>
          </div>

          <div className="custom-packages">
            <h3><FaHandshake className="section-icon" />Custom Packages</h3>
            <p>We also offer customized sponsorship packages tailored to your business needs and goals. Let's work together to create a partnership that benefits both your business and our BBQ community.</p>
          </div>
        </div>
      </div>

      <div className="info-card contact-card">
        <FaEnvelope className="card-icon" />
        <div className="card-content">
          <h2>Become a Sponsor</h2>
          <p>Ready to partner with us? Get in touch to discuss sponsorship opportunities!</p>
          
          <div className="contact-info">
            <div className="contact-item">
              <FaPhone className="contact-icon" />
              <div className="contact-details">
                <span className="contact-label">Call Us</span>
                <a href="tel:956-588-8168" className="contact-value">
                  (956) 588-8168
                </a>
              </div>
            </div>
            
            <div className="contact-item">
              <FaEnvelope className="contact-icon" />
              <div className="contact-details">
                <span className="contact-label">Email Us</span>
                <a href="mailto:moisessegovia588@gmail.com" className="contact-value">
                  moisessegovia588@gmail.com
                </a>
              </div>
            </div>
          </div>

          <div className="why-sponsor">
            <h3>Why Sponsor Our Event?</h3>
            <div className="why-grid">
              <div className="why-item">
                <FaUsers className="why-icon" />
                <span>Connect with 500+ BBQ enthusiasts and families</span>
              </div>
              <div className="why-item">
                <FaHeart className="why-icon" />
                <span>Support local community and youth programs</span>
              </div>
              <div className="why-item">
                <FaBullhorn className="why-icon" />
                <span>Increase brand visibility and recognition</span>
              </div>
              <div className="why-item">
                <FaHandshake className="why-icon" />
                <span>Build lasting relationships in the community</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Sponsors; 